const accessVendor = {
    VENDOR_LIST: { name: 'Vendor', path: '/vendor-list' },
    VENDOR_APPROVAL: { name: 'Vendor Approval', path: '/vendor-approval' },
    VENDOR_DETAILS: { name: 'Vendor Details', path: '/vendor-details' },
    VENDOR_SERVICE_LIST: { name: 'Vendor Service List', path: '/vendor/service-list' }
}

export default accessVendor;